import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';
import LanguagePickerNavigationContainer from '../ContainersBrafab/LanguagePickerNavigationContainer';

const NavigationItem = ({ links = [], contentLink = null, additionalLinks = [], root = true }) => {
    const isB2bChannel = useSelector((state) => state.channels.channelIsB2B);
    const isBusinessCustomer = useSelector((state) => state.myPage.isBusinessCustomer);
    const menuRef = useRef();
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const isFreeText = contentLink && contentLink.attributes && contentLink.attributes.cssValue == "free-text" ? true : false;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const isActive = contentLink ? contentLink.isSelected : '';

    function toggleMenu(e) {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
        const navItem = menuRef.current.closest('.navbar__item');
        if (navItem) {
            navItem.classList.toggle('navbar__menu--showing');
            const navParent = menuRef.current.closest('ul');
            if (navParent) {
                navParent.classList.toggle('navbar__menu--has-active-sub');
            }
        }
        // Toggle body
        const bodyEl = document.querySelector('body');
        if (bodyEl) {
            const isTopElActive = document.querySelector('.navbar > .navbar__menu--show');
            if (isTopElActive) {
                bodyEl.classList.add('navbar__menu--is-active');
            } else {
                bodyEl.classList.remove('navbar__menu--is-active');
            }
        }
    }

    return (
        <Fragment>
            {!contentLink ? (
                <button className="navbar__link--block navbar__icon--menu navbar__icon" aria-labelledby="mobilemenulabel" onClick={toggleMenu}><label id="mobilemenulabel">{translate('common.mobile.menu')}</label></button>
            ) : (
                <Fragment>
                    {isFreeText ?
                        <div className={additionClass}>{contentLink.name}</div>
                        :
                        <Fragment>
                            {
                                (contentLink.url || hasChildrenClass || contentLink.name) &&
                                <a className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''} ${isActive ? 'active' : ''}`}
                                    href={contentLink.url || '#'} onClick={hasChildrenClass ? toggleMenu : null} dangerouslySetInnerHTML={{ __html: contentLink.name }} >
                                </a>
                            }
                        </Fragment>
                    }
                    {links.length > 0 &&
                        <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                    }
                </Fragment>
            )}

            {links.length > 0 &&
                <div className="navbar__menu" ref={menuRef} test={links.length}>
                    <ul className="main-links">
                        <li className="navbar__menu-header">
                            <div>
                                {!contentLink ? (
                                    <Fragment></Fragment>
                                ) : (
                                    <Fragment>
                                        <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                                            <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: translate('common.mobile.menu.back') }}></span>
                                    </Fragment>
                                )}
                            </div>
                        </li>

                        {links.length > 0 && links.map((link, i) => !link.name ?
                            <Fragment key={i}>
                                {link.showAsGrid && link.links.length > 0 &&
                                    <li className="navbar__item grid-list-item" key={`gridView-${i}`}>
                                        <ul className="image-grid-container row small-up-1 large-up-3">
                                            {link.links.map((gridLink, gridLinkIndex) => (
                                                <li className="columns column-block" key={`Grid-Link${gridLinkIndex}`}>
                                                    <a className={`navbar__link ${additionClass || ''} ${isActive ? 'active' : ''}`}
                                                        href={gridLink.url || '#'} >
                                                        {gridLink.imageUrl ?
                                                            <img alt={gridLink.name} loading="lazy" className="page-thumbnail-image" src={gridLink.imageUrl} />
                                                            :
                                                            <div className="page-thumbnail-image page-thumbnail-image--missing"><i className="fa fa-picture-o" aria-hidden="true"></i></div>
                                                        }
                                                        <div className="link-text">{gridLink.name}</div>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul></li>
                                }</Fragment>
                            :
                            <li className="navbar__item" key={`${link.name}-${i}`}>
                                <NavigationItem links={link.links} contentLink={link} root={false} />
                            </li>
                        )}
                    </ul>
                    {!contentLink && (additionalLinks.topLinkList || additionalLinks.alternativeHeaderLinks) &&
                        <ul className="extra-links-wrapper extra-links">
                            {isB2bChannel &&
                                <Fragment>
                                    {isBusinessCustomer ?
                                        <li>
                                            <input id="myAccountLink" type="checkbox" name="menu" />
                                            <label htmlFor="myAccountLink" className="language-header-label-mobile">{translate('common.websiteselector.myaccount')} <i className="navbar__icon--caret-down navbar__icon"></i></label>
                                            <ul className="extra-links">
                                                {!contentLink &&
                                                    <Fragment>
                                                        {additionalLinks.topLinkList && additionalLinks.topLinkList.map((link, linkIndex) => !link.accessibleByUser ? null :
                                                            <li className="navbar__item top-links hide-for-large link-menu-item" key={`link${linkIndex}`}>
                                                                <a className={`navbar__link ${isActive ? 'active' : ''}`} href={link.href}>{link.text}</a>
                                                            </li>
                                                        )}
                                                    </Fragment>
                                                }
                                                {!contentLink && additionalLinks.alternativeHeaderLinks && additionalLinks.alternativeHeaderLinks.map((link, alternativeLinkIndex) => link.HideForUser ? null :
                                                    <li className="navbar__item top-links hide-for-large link-menu-item" key={`link${alternativeLinkIndex}`}><a className={`navbar__link ${isActive ? 'active' : ''}`} href={link.linkUrl} >{link.linkName}</a></li>
                                                )}
                                            </ul>
                                        </li>
                                        :
                                        <li>
                                            <ul>
                                                <Fragment>
                                                    {!contentLink && additionalLinks.topLinkList && additionalLinks.topLinkList.map((link, linkIndex) => !link.accessibleByUser ? null :
                                                        <li className="navbar__item top-links hide-for-large" id="mobile-login" key={`link${linkIndex}`}>
                                                            <a className={`navbar__link ${isActive ? 'active' : ''}`} href={link.href}>{link.text}</a>
                                                        </li>
                                                    )}
                                                </Fragment>
                                            </ul>
                                        </li>
                                    }
                                </Fragment>
                            }
                            {!isB2bChannel &&
                                <li>
                                    <ul className="extra-links">
                                        {!contentLink &&
                                            <Fragment>
                                                {additionalLinks.topLinkList && additionalLinks.topLinkList.map((link, linkIndex) => !link.accessibleByUser ? null :
                                                    <li className="navbar__item top-links hide-for-large" id="mobile-login" key={`link${linkIndex}`}>
                                                        <a className={`navbar__link ${isActive ? 'active' : ''}`} href={link.href}>{translate('common.websiteselector.login')}</a>
                                                    </li>
                                                )}
                                            </Fragment>
                                        }
                                        {!contentLink && additionalLinks.alternativeHeaderLinks && additionalLinks.alternativeHeaderLinks.map((link, alternativeLinkIndex) => link.HideForUser ? null :
                                            <li className="navbar__item top-links hide-for-large" key={`link${alternativeLinkIndex}`}><a className={`navbar__link ${isActive ? 'active' : ''}`} href={link.linkUrl} >{link.linkName}</a></li>
                                        )}
                                    </ul>
                                </li>
                            }
                        </ul>
                    }
                    {!contentLink &&
                        <ul className="extra-links language-picker-mobile-menu">
                            <li className="navbar__item top-links hide-for-large"><LanguagePickerNavigationContainer isMobile={true} /></li>
                        </ul>
                    }
                </div>
            }
        </Fragment>
    );
};

export default NavigationItem;
